import get from "lodash/get";

const TIMEOUT = process.env.NODE_ENV ? 900000 : 120000; // 2 minutes for dev, 15 for production. Same as the server's timeout
/**
 * Ensure logged in / loaded activeUser's coach is not currently editing their calendar'.
 */
const isCoachEditing = async ({ req, res, load, locals, login }, next) => {
  if (!locals.activeUser) return next();
  locals.activeUser.isCoachEditing = !isExpired(
    get(locals, "activeUser.coachCalendarEditlastActive")
  );
  return next();
};

function isExpired(lastActive) {
  if (!lastActive) return true;
  // ensuring lastActive is of instance date
  lastActive = new Date(lastActive);
  const time = lastActive.getTime();
  if (!time) throw new TypeError("Invalid Coach Last Active Time");

  const now = Date.now();
  return now - time > TIMEOUT;
}

export default isCoachEditing;
